import {
  PHOTO_ZOOM,
} from '@common/constants/features';

export default {
  namespaced: true,

  state: () => ({
    galleryMedia: [],
    toShowIndex: 0,
    isZoomDisabled: false,
  }),

  getters: {
    // eslint-disable-next-line max-params
    isFeatureEnabled: (state, getters, rootState, rootGetters) => rootGetters['features/$isFeatureEnabled'](PHOTO_ZOOM),
    isGalleryShown: (state, getters) => getters.isFeatureEnabled && !!state.galleryMedia?.length,
    toShowIndex: (state) => state.toShowIndex,
    galleryMedia: (state) => state.galleryMedia,
  },

  actions: {
    showGallery({ commit, getters }, { gallery, toShowIndex = 0, zoomDisabled = false }) {
      if (!getters.isFeatureEnabled) return;

      commit('setGalleryMedia', gallery);
      commit('setIndex', toShowIndex);
      commit('setZoomDisabled', zoomDisabled);
    },
  },

  mutations: {
    setGalleryMedia(state, gallery) {
      state.galleryMedia = gallery.map((media) => ({
        large: { url: media.large },
        thumb: { url: media.thumb },
      }));

      state.galleryMedia = gallery.map((media) => {
        // для картинок из отзывов
        if (media?.large && media?.thumb) {
          return {
            large: { url: media.large },
            thumb: { url: media.thumb },
          };
        }

        return {
          large: media,
          thumb: media,
        };
      });
    },
    setIndex(state, toShowIndex) {
      state.toShowIndex = toShowIndex;
    },
    setZoomDisabled(state, isZoomDisabled) {
      state.isZoomDisabled = isZoomDisabled;
    },
    hideGallery(state) {
      state.galleryMedia = [];
      state.toShowIndex = 0;
      state.isZoomDisabled = false;
    },
  },
};
